import LimitReachedModal from "@src/modules/member/modules/settings/billing/_shared/limit-reached-modal";
import { Outlet } from "react-router-dom";

export function LoginRoute() {
  return (
    <div className="h-full">
      <Outlet />
      <LimitReachedModal />
    </div>
  );
}

export default LoginRoute;
